import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Countdown from "react-countdown";
import { base_url } from "../Api/Api";

const ItemAward = (props) => {
  const [state, setState] = useState({
    data: props.data, // api data
    timeStyle: false, // color background timer
    days: 0,
    hours: 0,
    minutes: 0,
    disBtn: false,
    url: "",
  });

  useEffect(() => {
    let url = `${
      state.data == null
        ? 0
        : state.data.status === 0
        ? "/lottery/expired"
        : "/lottery/details"
    }/
        ${state.data == null ? 0 : state.data.id}`;
    setState({
      ...state,
      url: url.trim(),
    });
    console.log(props, "item props");
  }, []);

  const Days = useRef(0);
  const Hours = useRef(0);
  const Minutes = useRef(0);

  const disableBtn = () => {
    setState({
      ...state,
      disBtn: true,
    });
  };

  // Renderer callback with condition
  const timerRender = ({ days, hours, minutes, completed }) => {
    if (
      Days.current.innerText != undefined &&
      Hours.current.innerText != undefined &&
      Minutes.current.innerText != undefined
    ) {
      Days.current.innerText = days;
      Hours.current.innerText = hours == 0 ? "00" : hours;
      Minutes.current.innerText = minutes == 0 ? "00" : minutes;
    }
    if (completed) {
      return (
        <>
          <span>00</span>
          <span>00</span>
          <span>0</span>
        </>
      );
    } else {
      // Render a countdown
      return (
        <span>
          {days}:{hours}:{minutes}
        </span>
      );
    }
  };

  return (
    <div
      className={`item-award ${
        state.data.length == 0
          ? ""
          : state.data.time_secound <= 0
          ? "expire"
          : ""
      }`}
    >
      <div className="pic">
        <img src="/icons/Group 4809.svg" />
      </div>
      <h4>{state.data == null ? "" : state.data.title}</h4>
      <div className="imgesBall">
        <img src={`${state.data.image}`} />
      </div>
      {state.data.time_secound <= 0 ? (
        <span></span>
      ) : (
        <div className="time">
          <span>زمان باقی مانده تا قرعه کشی</span>
          <div className="conter">
            <span ref={Days}>{state.days}</span>
            <span>روز</span>
          </div>
          <div className="conter">
            <span ref={Hours}>{state.hours}</span>
            <span>ساعت</span>
          </div>
          <div className="conter">
            <span ref={Minutes}>{state.minutes}</span>
            <span>دقیقه</span>
          </div>
          <div className="cmpnt-timer">
            {state.data == null ? null : (
              <Countdown
                date={Date.now() + state.data.time_secound * 1000}
                renderer={timerRender}
              />
            )}
          </div>
        </div>
      )}
      {state.data == null ? (
        ""
      ) : state.data.register_count == 0 ? (
        <span className="count-register">
          شما در این قرعه کشی شرکت نکرده اید
        </span>
      ) : (
        <span className="count-register">
          تعداد دفعات شرکت در این قرعه کشی : {state.data.register_count}
        </span>
      )}
      <div className="row-scors">
        <div className="scrs">
          <span>امتیاز شما : </span>
          <b>{state.data == null ? "" : state.data.user_score}</b>
        </div>
        <div className="scrs">
          <span>حداقل امتیاز : </span>
          <b>{state.data == null ? "" : state.data.required_score}</b>
        </div>
      </div>
      <span
        style={{
          margin: "1rem",
          textAlign: "center",
          width: "100%",
          justifyContent: "center",
          color: "red",
        }}
        className={`error-respns ${
          props.error.id === state.data.id ? "active" : ""
        }`}
      >
        {props.error.message}
      </span>
      <div className="btn-base btn-black btn-sircle">
        {state.data == null ? (
          0
        ) : state.data.can_register ? (
          <Button
            variant="contained"
            disabled={state.disBtn}
            onClick={() => {
              disableBtn();
              props.lotteryRegister(
                state.data.id,
                state.data.user_score,
                state.data.required_score
              );
            }}
          >
            شرکت در قرعه کشی
          </Button>
        ) : (
          <div className="btn-expire">
            {state.data.time_secound <= 0 ? (
              <Button variant="contained">قرعه کشی به پایان رسیده</Button>
            ) : (
              <Button variant="contained">شرکت در قرعه کشی</Button>
            )}
          </div>
        )}
      </div>
      <Link to={state.url}>جزییات بیشتر</Link>
    </div>
  );
};

export default ItemAward;
